// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { toast } from 'sonner';

/**
 * Nuke every cache + service worker, then hard-reload the page.
 * Helps when a stale PWA bundle is causing weird behavior in production.
 *
 * Safe to call multiple times — each step is wrapped in its own try/catch
 * so any single failure doesn't block the others.
 */
export async function forceAppRefresh() {
  const safe = async (label, fn) => {
    try { await fn(); }
    catch (e) { console.warn(`[forceRefresh] ${label} failed:`, e); }
  };

  toast.info('Atualizando aplicativo... a página vai recarregar.');

  // Unregister all service workers
  await safe('SW unregister', async () => {
    if (!('serviceWorker' in navigator)) return;
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map(r => r.unregister()));
  });

  // Delete every Cache Storage entry
  await safe('caches.delete', async () => {
    if (!('caches' in window)) return;
    const keys = await caches.keys();
    await Promise.all(keys.map(k => caches.delete(k)));
  });

  // Clear app-managed sessionStorage flags (but KEEP auth token so the
  // user doesn't need to log in again after the reload).
  await safe('sessionStorage clear (non-auth)', async () => {
    // Preserve only the auth token
    const token = sessionStorage.getItem('token');
    sessionStorage.clear();
    if (token) sessionStorage.setItem('token', token);
  });

  // Force-reload bypassing HTTP cache where supported.
  setTimeout(() => {
    window.location.reload(true);
  }, 600);
}
